import React from 'react';
import { Download, File, FileText } from 'lucide-react';

const labels = {
  ne: {
    title: 'डाउनलोड',
    subtitle: 'यस क्षेत्रसँग सम्बन्धित दस्तावेजहरू।',
    download: 'डाउनलोड',
  },
  en: {
    title: 'Downloads',
    subtitle: 'Documents related to this sector.',
    download: 'Download',
  },
};

const SectorDownloads = ({ downloads, language = 'ne' }) => {
  const t = labels[language] || labels.ne;

  if (!downloads || downloads.length === 0) {
    return null;
  }

  const getFileIcon = (type) => {
    if (type === 'PDF') return <FileText size={24} />;
    if (type === 'DOC') return <File size={24} />;
    return <FileText size={24} />;
  };

  return (
    <section className="sector-downloads">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">{t.title}</h2>
          <p className="section-subtitle">{t.subtitle}</p>
        </div>

        <div className="downloads__grid">
          {downloads.map((doc, index) => (
            <div key={index} className="download-card">
              <div className="download-card__icon">
                {getFileIcon(doc.type)}
              </div>
              <div className="download-card__content">
                <div className="download-card__type">{doc.type}</div>
                <h3 className="download-card__title">{doc.title}</h3>
                <p className="download-card__description">{doc.description}</p>
                <a href={doc.fileUrl} className="download-card__btn" download>
                  <Download size={18} />
                  {t.download}
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SectorDownloads;
